function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Interface / External_Link"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.33333 4.16671H6.83333C5.89991 4.16671 5.43285 4.16671 5.07633 4.34836C4.76273 4.50815 4.50795 4.76293 4.34816 5.07654C4.1665 5.43306 4.1665 5.90012 4.1665 6.83354V13.1669C4.1665 14.1003 4.1665 14.5668 4.34816 14.9233C4.50795 15.2369 4.76273 15.4921 5.07633 15.6519C5.43251 15.8334 5.899 15.8334 6.83059 15.8334H13.1691C14.1007 15.8334 14.5665 15.8334 14.9227 15.6519C15.2363 15.4921 15.4919 15.2366 15.6517 14.923C15.8332 14.5669 15.8332 14.1009 15.8332 13.1693V11.6667M16.6665 7.50004V3.33337M16.6665 3.33337H12.4998M16.6665 3.33337L10.8332 9.16671",
  stroke: "#00C4B5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/External_Link.8423e8f5.svg";
export { ForwardRef as ReactComponent };